var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/array-slice.js
// module id = 428
// module chunks = 0